import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import * as IoIcons from "react-icons/io";
import Swal from "sweetalert2";
function EditarDocumentacion(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [postEstado, setPostEstado] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const Eliminar = (e) => {
    e.preventDefault(e);
    if (postEstado != "") {
      setLoading(true);
      axios({
        method: "put",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ActualizaEstadosAnexos?IdAnexo=" +
          props.id,
        data: {
          Estado: postEstado,
        },
      })
        .then((Response) => {
          console.log(Response.data);
          Swal.fire({
            title: "Actualizado con exito!",
            text: "Añadido.",
            icon: "success",
            timer: 3500,
          });
          window.location.reload("/");
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error al cambiar",
            text: "Intente de nuevo.",
            icon: "warning",
            timer: 3500,
          });
        });
    }
  };
  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Editar
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear "
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Aprobacion de Documentos
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive"></div>
                  <form className="user">
                    <div className="form-group row">
                      <div className="col-sm-12 ">
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          onChange={(e) => setPostEstado(e.target.value)}
                        >
                          <option value="">Seleccione </option>
                          <option value="1">Aprobado </option>
                          <option value="0">Sin Aprobar </option>
                        </select>
                      </div>
                    </div>
                    {postEstado == "0" ? (
                      <div className="form-group row">
                        <div className="col-sm-12 ">
                          <textarea
                            type="text"
                            className="form-control form-control-user"
                            placeholder="Comentarios"
                            onChange={(e) => "setPostDireccion"(e.target.value)}
                          />
                        </div>
                      </div>
                    ) : (
                      <h1></h1>
                    )}

                    <p>
                      {!isLoading && (
                        <button
                          className="btn btn-primary btn-user btn-block"
                          onClick={Eliminar}
                        >
                          {" "}
                          Guardar{" "}
                        </button>
                      )}
                      {isLoading && (
                        <button
                          type="submit"
                          name=""
                          className="btnContactSubmit btn-block"
                          disabled
                        >
                          <i className="btn btn-primary btn-user btn-block"></i>{" "}
                          Cargando...
                        </button>
                      )}
                    </p>
                    <hr className="sidebar-divider" />

                    <hr />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default EditarDocumentacion;
